<template>
  <div :class="isMobile ? '' : 'p-0 sidebar-col'" style="overflow-y: auto;">
    <div class="ham-menu" style="position: fixed;">
      <b-icon-list v-if="isMobile" @click="toggleSidebar" class="ham-menu-icon"></b-icon-list>
    </div>
    <b-col :class="isMobile ? 'mobileSidebar' : 'p-0 sidebar-col'" align-self="stretch" v-if="!hidden">
      <b-card class="sidebar-card scrollable-container" no-body>
        <!-- <h2 class="px-4 pt-2 pb-2">Nextex</h2> -->
        <div class="pb-2 pt-5 sidebar-header">
          <!-- <img src="@/assets/nextecLogo.png" alt="" class="img-to-fit px-4 py-2">{{username}} {{userEmail}} -->
          <img src="@/assets/lcs-letterhead-logo2-90x22.png" alt="" class="img-to-fit-sidebar" width="50%">
        </div>
        <b-nav vertical>
          <b-list-group-item>
            <router-link to="/home">
              <b-icon-house-door class="mr-2" style="color: #222222"></b-icon-house-door>
              <a style="color: #222222">Home</a>
            </router-link>
          </b-list-group-item>
          <MenuItem v-for="menuItem in menu" :key="menuItem.name" :item="menuItem" />
          <b-list-group-item v-b-toggle.admin>
            <b-icon-person-badge class="mr-2"></b-icon-person-badge>
            Admin
          </b-list-group-item>
          <b-collapse id="admin" accordion="admin">
            <b-list-group>
              <router-link to="/admin/ManageUser/SearchUser">
                <b-list-group-item>
                  <b-icon-people-fill class="mr-2"></b-icon-people-fill>
                  Users
                </b-list-group-item>
              </router-link>
            </b-list-group>
            <b-list-group>
              <router-link to="/admin/ManageRoles/SearchRole">
                <b-list-group-item>
                  <b-icon-person-plus-fill class="mr-2"></b-icon-person-plus-fill>
                  Roles
                </b-list-group-item>
              </router-link>
            </b-list-group>
            <b-list-group>
              <router-link to="/admin/ManageTags/SearchTag">
                <b-list-group-item>
                  <b-icon-person-lines-fill class="mr-2"></b-icon-person-lines-fill>
                  Tags
                </b-list-group-item>
              </router-link>
            </b-list-group>
            <b-list-group>
              <router-link to="/admin/ManageLinks/SearchLink">
                <b-list-group-item>
                  <b-icon-clipboard class="mr-2"></b-icon-clipboard>
                  Links
                </b-list-group-item>
              </router-link>
            </b-list-group>
            <b-list-group>
              <router-link to="/admin/ManageGroupings/GroupingSearch">
                <b-list-group-item>
                  <b-icon-clipboard class="mr-2"></b-icon-clipboard>
                  Groupings
                </b-list-group-item>
              </router-link>
            </b-list-group>
            <b-list-group>
              <router-link to="/admin/ManageOrganisations/SearchOrganisation">
                <b-list-group-item>
                  <b-icon-building class="mr-2"></b-icon-building>
                  Organisations
                </b-list-group-item>
              </router-link>
            </b-list-group>
          </b-collapse>
        </b-nav>
      </b-card>
    </b-col>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import api from '../api'
import MenuItem from '../components/MenuItem.vue'
import eventBus from '../eventBus';
export default {
  data: () => ({
    url: "",
    location: 'topics',
    username: null,
    userEmail: null,
    role: null,
    roles: [],
    services: [],
    apps: [],
    reports: [],
    documents: [],
    selectedEnvironment: 'Testing',
    loading: true,
    hidden: false,
    isMobile: true,
    userdata: null,
    redirectUrl: null,
    menu: {}
  }),
  components: {
    MenuItem
  },
  created() {
    eventBus.$on('on-click-link', this.navigateTo);
    if (this.sidebarMobileCheck()) {
      this.hidden = true;
      this.isMobile = true;
    }
    this.url = api.Url;
    var userdata = JSON.parse(localStorage.getItem("user_data"));
    this.role = JSON.parse(localStorage.getItem("role"));
    this.username = localStorage.getItem('user');
    this.userEmail = userdata.email
    if (this.role == null || userdata == null) {
      api.getUserID(userdata.email, (d) => userdata = d, console.error);
    }
    var tags_s = (tags) => {
      const allLinksSet = new Set();
      const tagMap = new Map(tags.map(tag => [tag.id, tag]));
      this.role.Tags.forEach(userTag => {
        const allowedTag = tagMap.get(userTag.Id);
        if (allowedTag) {
          allowedTag.links.forEach(item => {
            if (item.link.sideBar === true) {
              allLinksSet.add(item.link);
            }
          });
        }
      });
      const links = Array.from(allLinksSet);
      const flatLinks = links.map(({ grouping, ...rest }) => ({
        ...rest,
        parentGroupId: grouping.id,
      }));
      function buildGroupingHierarchy(ogArray, links, parentGroupId = null) {
        const groups = [];
        ogArray.forEach(item => {
          const { grouping, ...rest } = item;
          const groupLinks = [];
          const visitedUrls = new Set();

          links.forEach(link => {
            if (link.parentGroupId === grouping.id && !visitedUrls.has(link.url)) {
              groupLinks.push(link);
              visitedUrls.add(link.url);
            }
          });

          if (groupLinks.length > 0) {
            rest.links = groupLinks;
          }

          rest.showSubMenu = false;
          if (grouping.parentGroupId === parentGroupId) {
            const children = buildGroupingHierarchy(ogArray, links, grouping.id);
            if (children.length > 0) {
              rest.children = children;
            }
            groups.push(rest);
          }
        });
        return groups;
      }
      function extractGroupings(data) {
        const flatArray = [];
        const processedIds = new Set();
        data.forEach(item => {
          const { grouping } = item;
          if (grouping && grouping.id && !processedIds.has(grouping.id)) {
            const flatObject = {
              name: grouping.name,
              grouping: {
                ...grouping
              }
            };
            flatArray.push(flatObject);
            processedIds.add(grouping.id);
            // Check if the parentGroup exists
            const parentGroup = grouping.parentGroup;
            if (parentGroup && parentGroup.id && !processedIds.has(parentGroup.id)) {
              const parentFlatObject = {
                name: parentGroup.name,
                grouping: {
                  ...parentGroup
                }
              };
              flatArray.push(parentFlatObject);
              processedIds.add(parentGroup.id);
            }
          }
        });
        return flatArray;
      }
      const groupings = extractGroupings(links);
      this.menu = buildGroupingHierarchy(groupings, flatLinks);
    };
    api.getAllTags(tags_s, console.error)
    //we get the user over so we dont have to log in and out to get there updated roles
  },
  watch: {
    '$route'() {
      this.hidden = this.sidebarMobileCheck();
    }
  },
  methods: {
    toggleSidebar() {
      this.hidden = !this.hidden;
    },
    hasDocument(name) {
      return this.documents.some(document => document.name === name);
    },
    getDocument(name) {
      return this.documents.find(document => document.name === name);
    },
    sidebarMobileCheck() { return true },
    mobileAndTabletCheck() {
      // let check = false;
      // return true
      if (screen.width <= 820) {
        return true
      } else {
        return false
      }
      // eslint-disable-next-line
      // (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      // return check;
    },
    navigateTo(route) {
      if (route.url.startsWith("Zula")) {
        api.GetZulaDirectSignInUrl(this.userEmail, (url) => { window.open(url, '_blank'); }, console.error);
      } else if (route.target === "external") {
        window.open("https://" + route.url, '_blank');
      } else {
        if (route.type === "powerbi") {
          if (this.mobileAndTabletCheck()) {
            this.$router.push({ path: "/PowerBiViewer", query: { guid: route.powerBiMobile } })
          } else {
            this.$router.push({ path: "/PowerBiViewer", query: { guid: route.url } })
          }
        } else if (route.url.startsWith("DocumentWarehouse")) {
          this.$router.push({ path: "/"+route.url })
        } else if (route.url.startsWith("invoiceTracker")) {
          this.$router.push({ path: route.url })
        } else if (route.url.includes("vesselTracker")) {
          this.$router.push({ path: "/vesselTracker" })
        }
        else {
          this.$router.push({ path: '/IframeViewer', query: { url: route.url } })
        }
      }
    },
    loadRoles() {
    },
    ...mapActions(['logout']),
    changeEnvironment() {
      switch (this.selectedEnvironment) {
        case 'Production':
          this.selectedEnvironment = 'Testing'
          break;
        case 'Testing':
          this.selectedEnvironment = 'Production'
          break;
      }
    },
    changeLocation(newLocation) {
      this.$router.push({ path: newLocation })
      this.location = newLocation
    },
    logoutUser() {
      this.$router.push({ path: '/' })
      this.logout()
      localStorage.clear();
    }
  }
}
</script>
<style lang="scss">
.cursor {
  cursor: pointer;
}

.sidebar-header {
  h3 {
    font-size: 1.25rem;
    margin-bottom: 0;
  }

  @media (min-width: 820px) {
    padding-top: 5rem !important;
  }
}

.mobileSidebar {
  position: fixed;
  z-index: 100;
  padding: 0;
  margin: 0;
}

.scrollable-container {
  max-height: 100vh;
  overflow-y: auto;
}</style>